import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email address!').required('Email is required.'),
  password: yup.string().required('Password is required.').min(8),
  rememberMe: yup.boolean().required()
});

export default schema;
